import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AppService } from '../../../../../services';
import { StaffEngagementCountsWidget, StaffEngagementRow } from '../../../../../ui/widget/shared-tab-counts-table/staff-engagement-counts/staff-engagement-counts.widget';
import { AdmissionsAreaService } from '../../../admissions-area.service';


@Component({
	selector: 'admissions-engagements-tab-1-part',
	standalone: true,
	imports: [StaffEngagementCountsWidget],
	templateUrl: './admissions-engagements-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-engagements-tab-1.part.scss`],
})
export class AdmissionsEngagementsTab1Part {

	private areaService = inject(AdmissionsAreaService);
	private app = inject(AppService);

	public staffEngagementData = computed(() => {
		const admissionsData = this.areaService.admissionsData();
		if (!admissionsData) return [];

		// Group by staff
		const staffMap = new Map<number, { engagedCount: number; assignedCount: number }>();

		admissionsData.accProspects.forEach(record => {
			// Count engaged (lastContactStaffId)
			if (record.lastContactStaffId) {
				const engagedData = staffMap.get(record.lastContactStaffId) || { engagedCount: 0, assignedCount: 0 };
				engagedData.engagedCount++;
				staffMap.set(record.lastContactStaffId, engagedData);
			}

			// Count assigned (assignedToStaffId)
			if (record.assignedToStaffId) {
				const assignedData = staffMap.get(record.assignedToStaffId) || { engagedCount: 0, assignedCount: 0 };
				assignedData.assignedCount++;
				staffMap.set(record.assignedToStaffId, assignedData);
			}
		});

		// Convert to array format
		const staffEngagementRows: StaffEngagementRow[] = [];
		staffMap.forEach((counts, staffId) => {
			const staffName = this.app.getStaffNameById(staffId) || 'Unknown Staff';
			staffEngagementRows.push({
				staffId,
				staffName,
				engagedCount: counts.engagedCount,
				assignedCount: counts.assignedCount
			});
		});

		// Sort by staff name
		return staffEngagementRows.sort((a, b) => a.staffName.localeCompare(b.staffName));
	});

}
